import React, { createContext, useContext, useState, useEffect } from 'react';
import { getMe } from '../services/api';

const AuthContext = createContext({ client: null, loading: false, login: () => {}, logout: () => {} });

export function AuthProvider({ children }) {
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('clientToken');
    if (token) {
      getMe()
        .then(res => setClient(res.data))
        .catch(() => {
          localStorage.removeItem('clientToken');
          setClient(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = (token, clientData) => {
    localStorage.setItem('clientToken', token);
    setClient(clientData);
  };

  const logout = () => {
    localStorage.removeItem('clientToken');
    setClient(null);
  };

  return (
    <AuthContext.Provider value={{ client, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
